import React, { useEffect, useState } from 'react';
import Paginacao from '../../../../components/paginacao/Paginacao';
import TabelaSistema, { ColunaTabela } from '../../../../components/sync-painel/TabelaSistema';

interface Pagina<T> {
  total: number;
  porPagina: number;
  itens: T[];
}

interface Props<T> {
  titulo: string;
  dica: React.ReactNode;
  buscar: (pagina: number) => Promise<Pagina<T>>;
  colunas: ColunaTabela<T>[];
  chave: (item: T) => string;
  vazio: string;
  erro: string;
}

/**
 * A lista "quem, para quê, quando" de uma aba do Consumo de IA, paginada no servidor.
 *
 * 🔴 Falha de carga vira faixa de erro, NUNCA a frase de vazio (regra da at-60): "ninguém usou" e
 * "não consegui perguntar" levam a conclusões opostas sobre o gasto.
 */
function ListaPaginada<T>({ titulo, dica, buscar, colunas, chave, vazio, erro }: Props<T>) {
  const [pagina, setPagina] = useState(1);
  const [dados, setDados] = useState<Pagina<T> | null>(null);
  const [falhou, setFalhou] = useState(false);
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    let vivo = true;
    setCarregando(true);
    buscar(pagina)
      .then((r) => {
        if (!vivo) return;
        setDados(r);
        setFalhou(false);
      })
      .catch(() => {
        if (!vivo) return;
        setDados(null);
        setFalhou(true);
      })
      .finally(() => {
        if (vivo) setCarregando(false);
      });
    return () => {
      vivo = false;
    };
  }, [buscar, pagina]);

  const totalPaginas = dados ? Math.max(1, Math.ceil(dados.total / dados.porPagina)) : 1;

  return (
    <div className="admin-card" style={{ marginTop: 16 }}>
      <div className="admin-card-title">{titulo}</div>
      <p className="admin-hint">{dica}</p>
      {falhou ? (
        <p className="erro-de-tela">{erro}</p>
      ) : (
        <>
          <TabelaSistema
            colunas={colunas}
            itens={dados?.itens ?? []}
            chave={chave}
            vazio={vazio}
            carregando={carregando && !dados}
          />
          {dados && dados.total > dados.porPagina && (
            <Paginacao paginaAtual={pagina} totalPaginas={totalPaginas} onMudarPagina={setPagina} />
          )}
        </>
      )}
    </div>
  );
}

export default ListaPaginada;
